import {
  AMEX,
  JCB,
  Maestro,
  Mastercard,
  Meeza,
  Visa,
  Premium
} from '@unified-checkout/design-system/icons/payment_methods';
export const getCardLogo = (cardType: string) => {
  const cardTypeLowerCase = cardType.toLowerCase();
  switch (cardTypeLowerCase) {
    case 'visa':
      return Visa;
    case 'mastercard':
      return Mastercard;
    case 'maestro':
      return Maestro;
    case 'meezacard':
      return Meeza;
    case 'jcb':
      return JCB;
    case 'american-express':
      return AMEX;
    case 'premiumcard':
      return Premium;
    default:
      return '';
  }
};
